import { render, staticRenderFns } from "./PriceConfigurationPanel.vue?vue&type=template&id=07b277b4&scoped=true&lang=pug&"
import script from "./PriceConfigurationPanel.vue?vue&type=script&lang=js&"
export * from "./PriceConfigurationPanel.vue?vue&type=script&lang=js&"
import style0 from "./PriceConfigurationPanel.vue?vue&type=style&index=0&id=07b277b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b277b4",
  null
  
)

export default component.exports